export default __webpack_public_path__ + "static/media/TyperecordActive.52b5923b.svg";